import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c1e564b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "flex aitems-center justify-end mt-3"
}
const _hoisted_2 = {
  key: 2,
  class: "flex aitems-center justify-end mt-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "large UsersActions",
    title: _ctx.modalTitle,
    "confirm-button-text": _ctx.modalConfirmButtonText,
    "confirm-button-class": _ctx.isDelete ? 'small red' : undefined,
    "confirm-message": `Вы действительно хотите удалить пользователя ${_ctx.state.name}?`,
    "is-confirm": _ctx.isDelete,
    loading: _ctx.loading,
    onCancel: _ctx.emitCancel,
    onConfirm: _ctx.emitManager,
    "without-footer": _ctx.isUpdate
  }, {
    default: _withCtx(() => [
      _createVNode(_component_the_input, {
        class: "w-full",
        placeholder: "Имя",
        "is-invalid": _ctx.state_form$.name.$error,
        "validation-errors": _ctx.state_form$.name.$errors,
        value: _ctx.state.name,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.name) = $event))
      }, null, 8, ["is-invalid", "validation-errors", "value"]),
      _createVNode(_component_the_input, {
        class: "w-full mt-2",
        placeholder: "Email",
        "is-invalid": _ctx.state_form$.email.$error,
        "validation-errors": _ctx.state_form$.email.$errors,
        value: _ctx.state.email,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.email) = $event))
      }, null, 8, ["is-invalid", "validation-errors", "value"]),
      _createVNode(_component_the_input, {
        class: "w-full mt-2",
        placeholder: "Телефон",
        "is-invalid": _ctx.state_form$.phone.$error,
        "validation-errors": _ctx.state_form$.phone.$errors,
        value: _ctx.state.phone,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.phone) = $event))
      }, null, 8, ["is-invalid", "validation-errors", "value"]),
      _createVNode(_component_the_input, {
        class: "w-full mt-2",
        placeholder: "Пароль",
        "is-invalid": _ctx.state_form$.password.$error,
        "validation-errors": _ctx.state_form$.password.$errors,
        value: _ctx.state.password,
        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.password) = $event))
      }, null, 8, ["is-invalid", "validation-errors", "value"]),
      _createVNode(_component_the_select, {
        class: "w-full mt-3",
        placeholder: "Роль",
        "is-invalid": _ctx.state_form$.roles.$error,
        "validation-errors": _ctx.state_form$.roles.$errors,
        loading: _ctx.data_state.roles.is_loading,
        failed: _ctx.data_state.roles.is_failed,
        options: _ctx.data_state.roles.list,
        "error-text": "При получении списка ролей произошла ошибка",
        "infinite-scroll": "",
        multiselect: "",
        value: _ctx.state.roles,
        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.roles) = $event)),
        onRefresh: _cache[5] || (_cache[5] = ($event: any) => (_ctx.loadRoles(_ctx.data_state.roles.pagination.current_page))),
        onLoadmore: _cache[6] || (_cache[6] = ($event: any) => (_ctx.loadMoreRoles(_ctx.data_state.roles.pagination.current_page + 1))),
        onSearch: _ctx.searchRoles,
        onOptionBySearch: _ctx.unshiftFindedRole
      }, null, 8, ["is-invalid", "validation-errors", "loading", "failed", "options", "value", "onSearch", "onOptionBySearch"]),
      _createVNode(_component_the_select, {
        class: "mt-3",
        placeholder: "Компания",
        loading: _ctx.data_state.companies.is_loading,
        failed: _ctx.data_state.companies.is_failed,
        "is-invalid": _ctx.state_form$.company_id.$error,
        "validation-errors": _ctx.state_form$.company_id.$errors,
        "error-text": "При получении списка компаний произошла ошибка",
        options: _ctx.data_state.companies.list,
        value: _ctx.state.company_id,
        "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.company_id) = $event)),
        "infinite-scroll": "",
        onRefresh: _cache[8] || (_cache[8] = ($event: any) => (_ctx.loadCompanies(_ctx.data_state.companies.pagination.current_page))),
        onLoadmore: _cache[9] || (_cache[9] = ($event: any) => (_ctx.loadMoreCompanies(_ctx.data_state.companies.pagination.current_page + 1))),
        onSearch: _ctx.searchCompanies,
        onOptionBySearch: _ctx.unshiftFindedCompany
      }, null, 8, ["loading", "failed", "is-invalid", "validation-errors", "options", "value", "onSearch", "onOptionBySearch"]),
      _createVNode(_component_checkbox, {
        class: "mt-2",
        label: "Может видеть все заказы компании",
        value: _ctx.state.is_advanced,
        "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.is_advanced) = $event))
      }, null, 8, ["value"]),
      (_ctx.isUpdate)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_the_button, {
              class: "primary small",
              onClick: _ctx.emitManager
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Редактировать ")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isUpdate)
        ? (_openBlock(), _createBlock(_component_the_input, {
            key: 1,
            class: "w-full mt-2",
            placeholder: "Код 1С",
            disabled: _ctx.user_state.is_loading,
            value: _ctx.state.uuid_1c,
            "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.uuid_1c) = $event))
          }, null, 8, ["disabled", "value"]))
        : _createCommentVNode("", true),
      (_ctx.isUpdate)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_the_button, {
              class: "primary small",
              onClick: _ctx.onAdditionalAction
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Редактировать в кабинете ")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["title", "confirm-button-text", "confirm-button-class", "confirm-message", "is-confirm", "loading", "onCancel", "onConfirm", "without-footer"]))
}